import React from 'react';

const SCROLL_TRIGGER_PX = 320;

export default function BackToTop() {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > SCROLL_TRIGGER_PX);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={handleClick}
      className={[
        'fixed bottom-6 right-6 z-50 h-12 w-12 rounded-full shadow-lg',
        'bg-slate-900 text-white hover:bg-slate-800 focus:outline-none focus:ring-2',
        'focus:ring-offset-2 focus:ring-slate-400 transition-transform transition-opacity',
        'flex items-center justify-center',
        isVisible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-2 pointer-events-none',
      ].join(' ')}
    >
      <span className="text-xl leading-none">↑</span>
    </button>
  );
}
